module.exports = __webpack_public_path__ + "img/daily_necessities_sanitary.9dacab24.jpg";